export default __webpack_public_path__ + "static/stackswap-8f74b15536e974fb94c32bef79867acc.svg";